import { Fragment } from 'react';
import s from '#components/common/heroMeta/HeroMeta.module.scss';
import { getTranslatedMediaDuration } from '#utils/getMediaDuration';
import HeroMetaLivestreamInfos from '#components/common/heroMeta/HeroMetaLivestreamInfos';
import {
  Category,
  LivestreamDetails,
  LivestreamState,
} from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  fromAge?: string | number;
  year?: string | number;
  duration?: number;
  streamDetails?: LivestreamDetails;
  seasons?: unknown[] | string | number;
  genres?: Category[];
  mediaQuality?: string;
  audioFormat?: string;
  is360Video?: boolean;
  classes?: string;
};

const HeroMeta = ({
  fromAge,
  year,
  duration,
  streamDetails,
  seasons,
  genres,
  mediaQuality,
  audioFormat,
  is360Video,
  classes,
}: Props) => {
  const { t } = useTranslation();

  const seasonsTotal = Array.isArray(seasons) ? seasons.length : seasons;
  const mediaDurationString = getTranslatedMediaDuration(duration, t);
  const showDurationAndYear =
    !streamDetails || streamDetails?.streamState === LivestreamState.Archived;
  const videoFormat = is360Video ? '360°' : mediaQuality;

  return (
    <ul className={`${s.host} ${classes}`}>
      {streamDetails && (
        <HeroMetaLivestreamInfos streamDetails={streamDetails} />
      )}
      {fromAge && (
        <li className={`${s.item} ${s.isBoxOutline} ${s.hasNoDot}`}>
          <span className={s.itemInner}>
            <span className={'large-down:tw-hidden'}>{t('age')} </span>
            {fromAge}
          </span>
        </li>
      )}
      {year && showDurationAndYear && (
        <li className={s.item}>
          <span className={s.itemInner}>{year}</span>
        </li>
      )}
      {duration > 0 && showDurationAndYear && (
        <li className={s.item}>
          <span className={s.itemInner}>{mediaDurationString}</span>
        </li>
      )}
      {!!seasons && !!seasonsTotal && (
        <li className={s.item}>
          <span className={s.itemInner}>
            <Fragment>
              {seasonsTotal} {t('season', { count: seasonsTotal })}
            </Fragment>
          </span>
        </li>
      )}
      {genres && genres.length > 0 && (
        <li className={s.item}>
          {genres.map((item, index) => (
            <span className={`${s.itemInner} ${s.hasDivider}`} key={index}>
              {item.title}
            </span>
          ))}
        </li>
      )}
      {videoFormat && (
        <li className={`${s.item} ${s.isBoxColored}`}>
          <span className={s.itemInner}>{videoFormat}</span>
        </li>
      )}
      {audioFormat && (
        <li className={s.item}>
          <span className={s.itemInner}>{audioFormat}</span>
        </li>
      )}
    </ul>
  );
};

export default HeroMeta;
